module.exports = __webpack_public_path__ + "img/noMenu.42d4d514.png";